import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { TranslationContext } from "./hooks/useTranslationContext";

import ReactMarkdown from 'react-markdown';

export const Notification = ({
                                 severity,
                                 state,
                                 levelClass,
                                 location,
                                 source,
                                 type,
                                 isActive,
                                 onNotificationSelected,
                                 message,
                                 time,
                                 date
                             }) => {

    const t = useContext(TranslationContext);

    const sev = severity?.toLowerCase();
    const notState = state?.toLowerCase() || "open";

    let className = "item__notification " + levelClass;

    let description = [ source, location, type ].filter(e => e).join(" / ");
    return (
        <div className={"item" + (isActive ? " active": "")} onClick={ onNotificationSelected }>
            <div className="meta">
                <span className={sev}>{t("notifications.severity." + sev)}</span>
                <span className={"state " + notState}>{t("notifications.state." + notState)}</span>
            </div>
            <ReactMarkdown linkTarget={() => "_blank" }>{ message }</ReactMarkdown>
            <div className="meta small">
                { description && (
                    <strong>{ description }</strong>
                )}
                 · { time } · { date }
            </div>
        </div>
    );
}

